import React, { lazy, Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { ActionButtons, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import classNames from 'classnames';

var css_248z = ".X-DVV{height:250px;width:209px}[dir] .X-DVV{margin:0}.X-DVV.h-noo{height:330px;width:100%}[dir] .X-DVV.h-noo{margin:0 auto}.EbUqS{height:1px;width:inherit}[dir] .EbUqS{background:var(--ricos-settings-dividers-color,rgba(51,51,51,.1));border:none;margin:12px 0}[dir] .pwhy7{margin:0 12px}[dir] .pwhy7.h-noo{margin:5px 6px}";
var styles = {"colorPickerDialog":"X-DVV","mobile":"h-noo","colorPickerDialog_separator":"EbUqS","colorPickerDialog_buttons_wrapper":"pwhy7"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const CustomColorPicker = lazy(() => import('./CustomColorPicker.js'));
class CustomColorPickerDialog extends Component {
  constructor(props) {
    var _a;
    super(props);
    __publicField(this, "renderActionButtons", () => {
      const { t, isMobile, theme } = this.props;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles.colorPickerDialog_buttons_wrapper, {
            [styles.mobile]: isMobile
          })
        },
        /* @__PURE__ */ React.createElement(
          ActionButtons,
          {
            size: BUTTON_SIZE.tiny,
            isMobile,
            onCancel: this.onCancel,
            onSave: this.onUpdate,
            theme,
            t
          }
        )
      );
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.initialColor = props.color;
    this.state = {
      color: ((_a = props.color) == null ? void 0 : _a[0]) === "#" ? props.color : "#ffffff"
    };
    this.onCancel = this.onCancel.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  onChange(color) {
    this.setState({ color });
    this.props.onChange(color);
  }
  onCancel() {
    this.props.onCancel(this.initialColor);
  }
  onUpdate() {
    this.props.onUpdate(this.state.color);
  }
  render() {
    const { styles: styles2 } = this;
    const { t, isMobile, theme } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: classNames(styles2.colorPickerDialog, { [styles2.mobile]: isMobile }) }, isMobile && this.renderActionButtons(), /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(
      CustomColorPicker,
      {
        color: this.state.color,
        onChange: this.onChange,
        t,
        isMobile,
        theme
      }
    )), !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("hr", { className: styles2.colorPickerDialog_separator }), this.renderActionButtons()));
  }
}
CustomColorPickerDialog.propTypes = {
  t: PropTypes.func,
  color: PropTypes.string,
  isMobile: PropTypes.bool,
  theme: PropTypes.object,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func
};

export { CustomColorPickerDialog as default };
//# sourceMappingURL=CustomColorPickerDialog.js.map
